// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-preview {
  position: relative;
}
.onboarding-preview__buttons {
  padding: 0px 0px 1rem;
  position: absolute;
  z-index: 5;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: transparent;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.onboarding-preview__button {
  flex: 0 0 3rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: none;
  outline: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 2rem;
  padding: 0px;
  line-height: 1;
  margin-right: 1.75rem;
  background: #1DADB5;
  color: #FDFBFB;
}
.onboarding-preview__button:last-child {
  margin-right: 0px;
}
.onboarding-preview__button:hover, .onboarding-preview__button:focus {
  background: #00666F;
}
.onboarding-preview__button--inactive {
  background: #FF4958;
}
.onboarding-preview__button--inactive:hover, .onboarding-preview__button--inactive:focus {
  background: rgb(255, 47.5, 64.6016483516);
}
@media (max-width: 991px), (max-height: 699px) {
  .onboarding-preview__buttons {
    padding-bottom: 0.5rem;
  }
  .onboarding-preview__button {
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
    font-size: 1.25rem;
    margin-right: 0.75rem;
  }
}

.onboarding-config {
  padding: 1rem 0px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.onboarding-config__row, .onboarding-config .settings {
  display: flex;
  flex-wrap: nowrap;
}
.onboarding-config__col, .onboarding-config .settings__block {
  flex: 1 1;
}
.onboarding-config__preview {
  width: 100%;
  max-width: 36.5rem;
  margin: 0px auto 1.25rem;
}
.onboarding-config__preview .video-block {
  aspect-ratio: 16/9;
}
.onboarding-config__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  max-width: 665px;
  margin: 1.25rem auto 0px;
  width: 100%;
}
.onboarding-config__action {
  flex: 0 0 48%;
  font-size: 1rem;
  font-weight: 600;
  border-width: 2px;
  padding: 1rem;
}
.onboarding-config__toggle {
  flex: 0 0 auto;
  padding: 0.625rem 1rem;
}
.onboarding-config__capteurs {
  /*3rem */
  padding: 1rem;
}
.onboarding-config .settings__block {
  padding: 0.625rem;
}
.onboarding-config .device-selector {
  margin-bottom: 0.625rem;
}
.onboarding-config .device-selector__disable {
  display: none !important;
}
.onboarding-config .device-selector__container {
  width: 100% !important;
}
.onboarding-config .device-selector__label {
  text-align: center;
  font-family: "Filson Pro", sans-serif;
  font-weight: 500;
}
.onboarding-config .device-selector__input {
  font-family: "Omnes", sans-serif;
  font-weight: 600;
}
@media (max-width: 767px), (max-height: 575px) {
  .onboarding-config {
    /*.onetoone.onetoone--onBoarding .modal__body .onboarding-config__actions{
      width: fit-content;
      button{
        flex: 0 0 auto;
        margin: 0;
      }
    }*/
  }
  .onboarding-config__row, .onboarding-config .settings {
    flex-wrap: wrap;
  }
  .onboarding-config__col, .onboarding-config .settings__block {
    flex: 0 0 100%;
  }
  .onboarding-config__actions {
    max-width: none;
    margin: 0.625rem auto 0px;
  }
  .onboarding-config__action {
    /*flex: 0 0 100%;*/
    margin: 0.5rem auto;
    font-size: 0.875rem;
    padding: 0.75rem 1rem;
  }
  .onboarding-config__capteurs {
    padding: 1rem 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/OnBoarding.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/abstracts/_functions.scss"],"names":[],"mappings":"AAMA;EACE,kBAAA;AALF;AAOE;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAQE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,mBCtBa;EDuBb,cC/BW;ADyBf;AAQI;EACE,iBAAA;AANN;AASI;EAEE,mBC7BgB;ADqBtB;AAWI;EACE,mBC1CO;ADiCb;AAWM;EAEE,yCAAA;AAVR;AEiCE;EFjBE;IACE,sBAAA;EAbJ;EAeE;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,qBAAA;EAbJ;AACF;;AAkBA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAfF;AAiBE;EACE,aAAA;EACA,iBAAA;AAfJ;AAiBE;EACE,SAAA;AAfJ;AAmBE;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;AAjBJ;AAkBI;EACE,kBAAA;AAhBN;AAqBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,wBAAA;EACA,WAAA;AAnBJ;AAqBE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;AAnBJ;AAqBE;EACE,cAAA;EACA,sBAAA;AAnBJ;AAwBE;EACE,QAAA;EACA,aAAA;AAtBJ;AA6BI;EACE,iBAAA;AA3BN;AA+BE;EACE,uBAAA;AA7BJ;AA+BI;EACE,wBAAA;AA7BN;AA+BI;EACE,sBAAA;AA7BN;AA+BI;EACE,kBAAA;EACA,qCC7GU;ED8GV,gBAAA;AA7BN;AA+BI;EACE,gCChHa;EDiHb,gBAAA;AA7BN;AEvEE;EFsBF;IAyGI;;;;;;MAAA;EA9CF;EAwBE;IACE,eAAA;EAtBJ;EAwBE;IACE,cAAA;EAtBJ;EAyBE;IACE,eAAA;IACA,yBAAA;EAvBJ;EAyBE;IACE,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,qBAAA;EAvBJ;EA2BE;IACE,iBAAA;EAzBJ;AACF","sourcesContent":["@use '../abstracts/variables' as *;\n@use '../abstracts/functions';\n\n// -------------------------\n// Onboarding preview\n// -------------------------\n.onboarding-preview {\n  position: relative;\n\n  &__buttons {\n    padding: 0px 0px 1rem;\n    position: absolute;\n    z-index: 5;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background: transparent;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__button {\n    flex: 0 0 3rem;\n    width: 3rem;\n    height: 3rem;\n    border-radius: 50%;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-size: 2rem;\n    padding: 0px;\n    line-height: 1;\n    margin-right: 1.75rem;\n    background: $color__primary;\n    color: $color__white;\n\n    &:last-child {\n      margin-right: 0px;\n    }\n\n    &:hover,\n    &:focus {\n      background: $color__primary-dark;\n    }\n\n    &--inactive {\n      background: $color__red;\n\n      &:hover,\n      &:focus {\n        background: darken($color__red, 5%);\n      }\n    }\n  }\n\n  @include functions.responsiveNewTablet {\n    &__buttons {\n      padding-bottom: 0.5rem;\n    }\n    &__button {\n      flex: 0 0 2rem;\n      width: 2rem;\n      height: 2rem;\n      font-size: 1.25rem;\n      margin-right: 0.75rem;\n    }\n  }\n}\n\n\n.onboarding-config {\n  padding: 1rem 0px;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n\n  &__row {\n    display: flex;\n    flex-wrap: nowrap;\n  }\n  &__col {\n    flex: 1 1 0;\n  }\n\n  // Preview\n  &__preview {\n    width: 100%;\n    max-width: 36.5rem;\n    margin: 0px auto 1.25rem;\n    .video-block{ \n      aspect-ratio: 16 / 9;\n    }\n  }\n\n  // Buttons\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 665px;\n    margin: 1.25rem auto 0px;\n    width: 100%;\n  }\n  &__action {\n    flex: 0 0 48%;\n    font-size: 1rem;\n    font-weight: 600;\n    border-width: 2px;\n    padding: 1rem;\n  }\n  &__toggle {\n    flex: 0 0 auto;\n    padding: 0.625rem 1rem;\n  }\n\n\n  // Capteurs\n  &__capteurs {\n    /*3rem */\n    padding: 1rem;\n  }\n\n  // Settings\n  .settings {\n    @extend .onboarding-config__row;\n\n    &__block {\n      padding: 0.625rem;\n      @extend .onboarding-config__col;\n    }\n  }\n  .device-selector {\n    margin-bottom: 0.625rem;\n\n    &__disable {\n      display: none !important;\n    }\n    &__container {\n      width: 100% !important;\n    }\n    &__label {\n      text-align: center;\n      font-family: $font__ternary;\n      font-weight: 500;\n    }\n    &__input {\n      font-family: $font__quaternary;\n      font-weight: 600;\n    }\n  }\n\n  @include functions.responsiveMobile {\n    &__row {\n      flex-wrap: wrap;\n    }\n    &__col {\n      flex: 0 0 100%;\n    }\n    \n    &__actions {\n      max-width: none;\n      margin: 0.625rem auto 0px;\n    }\n    &__action {\n      /*flex: 0 0 100%;*/\n      margin: 0.5rem auto;\n      font-size: 0.875rem;\n      padding: 0.75rem 1rem;\n    }\n    \n    // Capteurs\n    &__capteurs {\n      padding: 1rem 0px;\n    }\n    /*.onetoone.onetoone--onBoarding .modal__body .onboarding-config__actions{\n      width: fit-content;\n      button{\n        flex: 0 0 auto;\n        margin: 0;\n      }\n    }*/\n  }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
